// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".profile img,.profile picture{width:100%;height:100%;-o-object-fit:cover;object-fit:cover}", ""]);
// Exports
module.exports = exports;
